exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
exports.push([module.id, ".video-scene>.video-container{position:absolute;top:0;left:0;right:0;bottom:0}.akamai-branding{display:none!important}.video-scene{position:relative}.video-scene:before{display:block;content:\"\";width:100%;padding-top:56.25%}.video-scene>.multimedia{position:absolute;top:0;left:0;right:0;bottom:0}", ""]);


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/autoprefixer-loader!./modules/video/ref_video.css
 ** module id = 5
 ** module chunks = 0
 **/